import { render, staticRenderFns } from "./Galary.vue?vue&type=template&id=629f72e1&scoped=true&"
import script from "./Galary.vue?vue&type=script&lang=js&"
export * from "./Galary.vue?vue&type=script&lang=js&"
import style0 from "./Galary.vue?vue&type=style&index=0&id=629f72e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629f72e1",
  null
  
)

export default component.exports